import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AuthService } from "app/auth/auth.service";
import ChangePassword from "models/users/password-change";
import {
  CompanyWorkgroup,
  UserProfile,
  UserWithWorkgroups,
} from "models/users/user-workgroups";
import { Observable } from "rxjs";
import OrganizationChange from "../../models/users/organization-change";
import SelectedOrganization from "../../models/users/selected-organization";
import { ConfigurationService } from "../configuration/configuration.service";

@Injectable()
class UsersService {
  private readonly usersServiceUrl: string;
  private readonly apiUrl: string;
  private readonly authService: AuthService;

  constructor(
    private http: HttpClient,
    private config: ConfigurationService,
    private auth: AuthService
  ) {
    this.apiUrl = config.getConfig().apiUrl;
    this.usersServiceUrl = config.getConfig().usersUrl;
    this.authService = auth;
  }
  /**
   * users-service-v2 uses the apiUrl
   */

  public changePassword(
    userId: string,
    password: ChangePassword
  ): Observable<void> {
    return this.http.put<void>(
      `${this.apiUrl}/users/${userId}/change-password`,
      password
    );
  }

  public async doesUserExist(userId: string): Promise<any> {
    const responseBody: any = await this.http
      .get(`${this.apiUrl}/users/user-exists/${userId}`)
      .toPromise();

    try {
      const parsedResponse: any = JSON.parse(responseBody);
      console.log({ parsedResponse });

      return parsedResponse.exists === "true";
    } catch {
      return responseBody.exists === true;
    }
  }

  public getUser(userId: string): Observable<UserWithWorkgroups> {
    return this.http
      .get<UserWithWorkgroups>(`${this.apiUrl}/users/${userId}`)
      .map((x) => {
        let y: UserWithWorkgroups = {
          active: x.active,
          createdDate: x.createdDate,
          tenantId: x.tenantId,
          updatedDate: x.updatedDate,
          userId: x.userId,
          userName: x.userName,
          workgroups: [],
        };

        for (let i = 0; i < x.workgroups.length; i++) {
          y.workgroups.push({
            createdDate: x.workgroups[i].createdDate,
            id: x.workgroups[i].id,
            updatedDate: x.workgroups[i].updatedDate,
            tenantId: x.workgroups[i].tenantId,
          });
        }

        return y;
      });
  }

  public getUserRoles(userId: string): Observable<CompanyWorkgroup[]> {
    return this.http.get<CompanyWorkgroup[]>(`${this.apiUrl}/${userId}/roles`);
  }

  public getUserProfile(userId: string): Observable<UserProfile> {
    return this.http.get<UserProfile>(`${this.apiUrl}/${userId}`);
  }

  /**
   * Changes the user's currently selected organization
   */
  public changeOrganization(organizationChange: OrganizationChange) {
    return this.http.post(
      `${this.usersServiceUrl}/updateChangeOrg`,
      organizationChange
    );
  }

  /**
   * Returns the user's selected organization
   */
  // master branch(replace)
  public getSelectedOrganization(
    userId: number
  ): Observable<SelectedOrganization> {
    return this.http
      .get<SelectedOrganization>(
        `${this.usersServiceUrl}/user?userId=${userId}`
      )
      .map((x: any) => {
        return {
          userId: x.UserId,
          organizationId: x.OrganizationId,
          organizationName: x.OrganizationName,
          userName: x.UserName,
          updatedDate: x.UpdatedDate,
        };
      });
  }
}

export { UsersService };



// WEBPACK FOOTER //
// ./src/providers/users-service/users.service.ts